const url = '/event';
const Provider = 'Events';
const dbModel = 'Events';

export { url, Provider, dbModel };
